import { catchError } from "rxjs/operators";
import { CookiesStorageService } from "../services/cookies-storage.service";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { User } from "../pojos/user";
import { BillingInfo } from "../services/payment-state.service";
import { PaymentType } from "../shared/util/constants";

@Injectable({
  providedIn: "root",
})
export class PaymentApiService {
  baseUrl: string = environment.baseUrl;
  constructor(
    private http: HttpClient,
    private cookieStorage: CookiesStorageService
  ) {}

  loginUserTemp(user: User) {
    return this.http
      .post(this.baseUrl + "/subscriber/login-temp", {
        ...user,
        type: "payment",
      })
      .toPromise();
  }

  getPaymentPlan(country: string) {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });

    return this.http
      .get(`${this.baseUrl}/payment/plan?country=${country}`, { headers })
      .pipe(
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  createPaymentRequest(
    planId: string,
    subID: string,
    billingInfo: BillingInfo
  ) {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .post(
        this.baseUrl + "/payment/request",
        {
          planId,
          subID,
          billingAddress: billingInfo,
          type: PaymentType.PLAN_PAYMENT,
        },
        { headers }
      )
      .toPromise();
  }

  createPaymentRequestForSMS(
    persms: number,
    purchaseSms: number,
    subID: string,
    billingInfo
  ) {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .post(
        this.baseUrl + "/payment/request",
        {
          persms,
          purchaseSms,
          type: PaymentType.SMS_PAYMENT,
          subID,
          billingAddress: billingInfo,
        },
        { headers }
      )
      .toPromise();
  }

  createPaymentRequestForBiometric(
    memberCount: number,
    perMemberPerDay: number,
    subID: string,
    billingInfo: BillingInfo
  ) {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .post(
        this.baseUrl + "/payment/request",
        {
          biometricMemberCount: memberCount,
          biometricPerMemberPrice: perMemberPerDay,
          type: PaymentType.BIOMETRIC_PAYMENT,
          subID,
          billingAddress: billingInfo,
        },
        { headers }
      )
      .toPromise();
  }

  getPaymentInformation(paymentId: string) {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .get(this.baseUrl + "/payment/info?paymentId=" + paymentId, { headers })
      .toPromise();
  }

  getSubscriberDetail(): Promise<any> {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http.get(this.baseUrl + "/subscriber", { headers }).toPromise();
  }

  generateTempAuthToken(token: string): Promise<any> {
    return this.http
      .get(this.baseUrl + "/subscriber/generate-session-token?key=" + token)
      .toPromise();
  }

  createRzpOrder(order: any): Promise<any> {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .post(this.baseUrl + "/payment/rzp-order", { ...order }, { headers })
      .toPromise();
  }

  getBillingAddress(subId: string): Promise<any> {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .get(
        this.baseUrl + `/gym/billing-address${subId ? `?subId=${subId}` : ""}`,
        {
          headers,
        }
      )
      .toPromise();
  }

  saveBillingAddress(address: any): Promise<any> {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .post(this.baseUrl + "/gym/billing-address", { ...address }, { headers })
      .toPromise();
  }

  getGymBranches(): Promise<any> {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .get(this.baseUrl + "/subscriber/all", { headers })
      .toPromise();
  }

  createPaymentQRCode(paymentId: string): Promise<any> {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .post(this.baseUrl + "/payment/qr-code", { paymentId }, { headers })
      .toPromise();
  }

  getPaymentStatus(paymentId: string): Promise<any> {
    let headers = new HttpHeaders({
      authToken: this.cookieStorage.getAuthToken(),
    });
    return this.http
      .get(this.baseUrl + "/payment/status?paymentId=" + paymentId, {
        headers,
      })
      .toPromise();
  }
}
